import logo from './logo.svg';
import './App.css';
import Header from './components/header';
import About from './components/about';
import Services from './service';
import Portfolio from './components/portfolio';
import Contact from './components/contact';

function App() {
  return (
    <>
    <Header/>
    <About/>
    <Services/>
    <Portfolio/>
    <Contact/>
    </>
  );
}

export default App;
